<template>
  <div class="home">
    <header-com></header-com>
    <div class="main">
      <div class="cont bs">
        <h3 class="title">学员报名</h3>
        <div class="wrap">
          <el-form style="margin-bottom: 20px" :inline="true" :model="formInline" size="small">
            <el-form-item style="width: 120px" prop="empName">
              <el-input v-model="formInline.empName" placeholder="姓名" clearable  @keyup.enter.native="onSearch"></el-input>
            </el-form-item>
            <el-form-item prop="empIdcard" style="width: 180px">
              <el-input v-model="formInline.empIdcard" placeholder="证件号码" clearable  @keyup.enter.native="onSearch"></el-input>
            </el-form-item>
            <el-form-item prop="affiliatedEnterprise">
              <el-input v-model="formInline.affiliatedEnterprise" placeholder="所属企业" clearable  @keyup.enter.native="onSearch"></el-input>
            </el-form-item>
            <el-form-item prop="postId">
              <el-select
                v-model="formInline.postId"
                placeholder="专业"
                clearable
                @change="specialChange"
              >
                <el-option
                  v-for="(item, i) in specialList"
                  :key="i"
                  :label="item.postName"
                  :value="item.postId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="batchId">
              <el-select v-model="formInline.batchId" placeholder="报名批次" clearable  @change="onSearch">
                <el-option
                  v-for="(item, i) in batchList"
                  :key="i"
                  :label="item.batchName"
                  :value="item.batchId"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item prop="dataType">
              <el-select v-model="formInline.dataType" placeholder="报名类型" clearable>
                <el-option
                  v-for="(item, i) in dataTypeList"
                  :key="i"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item style="width: 120px" prop="agentId">
              <el-select
                v-model="formInline.agentId"
                placeholder="注册来源"
                clearable
                @change="activeState"
              >
                <el-option label="批量导入" value="0"></el-option>
                <el-option label="个人注册" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="regHasCourse">
              <el-select
                v-model="formInline.regHasCourse"
                placeholder="课程激活状态"
                clearable
                @change="activeState"
              >
                <el-option label="未激活" value="0"></el-option>
                <el-option label="已激活" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="sysDeleted" style="width: 150px">
              <el-select
                v-model="formInline.sysDeleted"
                placeholder="选择状态"
                clearable
                @change="stateChange"
              >
                <el-option label="正常" value="0"></el-option>
                <el-option label="已作废" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="annualFlag" style="width: 150px">
              <el-select
                v-model="formInline.annualFlag"
                placeholder="标记类型"
                clearable
                @change="onSearch"
              >
                <el-option label="否" value="0"></el-option>
                <el-option label="是" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="suspensionType" style="width: 150px">
              <el-select
                v-model="formInline.suspensionType"
                placeholder="是否停学"
                clearable
                @change="onSearch"
              >
                <el-option label="否" value="0"></el-option>
                <el-option label="是" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-date-picker
              class="picker"
              style="margin-right: 10px"
              v-model="applyValue"
              type="datetimerange"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="报名时间起"
              end-placeholder="报名时间止"
              size="small"
              align="right"
              value-format="yyyy-MM-dd HH:mm:ss"
              unlink-panels
              @change="onSearch"
            ></el-date-picker>
            <el-date-picker
              class="picker"
              style="margin-right: 10px"
              v-model="couseActiveValue"
              type="datetimerange"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="课程激活起"
              end-placeholder="课程激活止"
              size="small"
              align="right"
              value-format="yyyy-MM-dd HH:mm:ss"
              unlink-panels
              @change="onSearch"
            ></el-date-picker>
            <el-button style="margin-right: 10px" type="primary" size="small" @click="onSearch">查询</el-button>
            <el-button
              style="margin-left: 0"
              type="success"
              size="small"
              @click="
                (applyDialog = true),
                  (btnType = 0),
                  (title = '新增报名信息'),
                  (isSpecial = false),
                  (isdataType = false),
                  (isCard = false)
              "
            >新增报名信息</el-button>
            <el-button type="primary" size="small" @click="manageDialog = true">批次管理</el-button>
            <el-button type="primary" size="small" @click="batchDialog = true">批量导入报名信息</el-button>
            <el-button type="success" size="small" :disabled="isDisabled" @click="activeBtn">激活课程</el-button>
            <el-button type="warning" size="small" :disabled="isDisabled" @click="suspensionMarkClick(0)">停学标记</el-button>
            <el-button type="danger" size="small" :disabled="isDisabled" @click="cancelSuspensionMarkMarkClick(1)">取消停学标记</el-button>
            <el-button type="primary" style="margin-top:10px;" size="small" @click="exportApply">批量导出报名信息</el-button>
          </el-form>
          <!-- <div class="btns"></div> -->
          <el-table
            :data="infoList"
            border
            max-height="600"
            ref="fileTable"
            :cell-style="cellStyle"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
            @row-click="rowClick"
            @selection-change="selectioChange"
            highlight-current-row
            :header-cell-style="{ background: '#dde9fc', color: '#606266' }"
          >
            <el-table-column :selectable="selectable" type="selection" width="50"></el-table-column>
            <el-table-column type="index" width="50" label="序号"></el-table-column>
            <el-table-column prop="regName" label="姓名" min-width="80"></el-table-column>
            <el-table-column prop="regSex" :formatter="sexFormat" label="性别" width="80"></el-table-column>
            <el-table-column prop="regIdcard" label="身份证号" min-width="180"></el-table-column>
            <el-table-column prop="regTel" label="手机号" min-width="120"></el-table-column>
            <el-table-column prop="postName" label="专业" min-width="120"></el-table-column>
            <el-table-column
              prop="affiliatedEnterprise"
              label="所属企业"
              min-width="120"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column prop="batchName" label="报名批次" show-overflow-tooltip min-width="120"></el-table-column>
            <el-table-column prop="agentId" label="注册方式" :formatter="orderFormat" width="100"></el-table-column>
            <el-table-column prop="regCertificateNum" label="证书编号" width="130"></el-table-column>
            <el-table-column prop="regCertificateDate" label="证书发证时间" width="120"></el-table-column>
            <el-table-column prop="sysCreatetimeStr" label="报名时间" min-width="160"></el-table-column>
            <!-- <el-table-column
              prop="dataType"
              label="报名类型"
              min-width="80"
              :formatter="dataTypeFormatter"
            ></el-table-column> -->
            
            <el-table-column prop="suspensionType" label="是否停学" :formatter="suspensionFormat" width="120"></el-table-column>
            <!-- <el-table-column prop="regCategory" label="是否有后台权限" :formatter="hasFormat" width="120"></el-table-column> -->
            <el-table-column prop="learnYear" min-width="120" label="继续教育年份"></el-table-column>
            <!-- <el-table-column label="继续年度标记" min-width="120">
              <template slot-scope="scope">
                {{scope.row.annualFlag==0?'否':'是'}}
              </template>
            </el-table-column> -->
            <el-table-column
              prop="regHasCourse"
              :formatter="stateFormat"
              min-width="120"
              label="课程激活状态"
            ></el-table-column>
            <el-table-column prop="activeTimeStr" min-width="160" label="课程激活时间"></el-table-column>
            <el-table-column prop="sysDeleted" label="状态" :formatter="sysFormat" width="100"></el-table-column>
            <el-table-column label="操作" width="160" fixed="right">
              <template slot-scope="scope">
                <el-button
                  @click="updateBtn(scope.row, scope.$index)"
                  type="primary"
                  size="mini"
                  :disabled="scope.row.sysDeleted == 2"
                >修改</el-button>
                <!-- <el-button @click="deleteBtn(scope.row,scope.$index,2,'作废')" type="warning" size="mini"
                v-if="scope.row.regHasCourse == 1 || scope.row.sysDeleted == 2" :disabled="scope.row.sysDeleted == 2">作废</el-button>-->
                <el-button
                  @click="deleteBtn(scope.row, scope.$index, 1, '删除')"
                  type="danger"
                  size="mini"
                  v-if="scope.row.regHasCourse == 0"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            :currentPage="currentPage"
            :total="total"
            :limit="limit"
            ref="page"
            @handleCurrentChange="handleCurrentChange"
            @handleSizeChange="handleSizeChange"
          />
        </div>
      </div>
      <!-- 新增报名信息 -->
      <el-dialog
        :title="title"
        :visible.sync="applyDialog"
        width="70%"
        center
        top="6vh"
        @close="resetForm('applyForm')"
      >
        <el-form
          id="addPop"
          class="info"
          ref="applyForm"
          :model="applyForm"
          :rules="applyRule"
          label-width="130px"
        >
          <el-form-item label="本人登记照：" ref="regHeadportrait">
            <el-upload
              class="avatar-uploader"
              accept=".jpg, .jpeg, .jif, .png"
              :action="uploadUrl"
              :show-file-list="false"
              :before-upload="beforeUpload"
              :on-success="handleAvatarSuccess"
              v-model="applyForm.regHeadportrait"
            >
              <img v-if="applyForm.regHeadportrait" :src="applyForm.regHeadportrait" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <!-- <div slot="tip" class="el-upload__tip">请上传jpg, gif, png格式的图片, 建议图片大小不超过2M</div> -->
              <div slot="tip" class="el-upload__tip">
                <h3>请上传符合要求的本人登记照片，否则证书记录将无效：</h3>
                <p>（1）本人近三个月内的正面、免冠、无妆、彩色（限白底色）电子证件照片；</p>
                <p>（2）照片类型为jpg、png格式，照片大小不超过80K；</p>
                <p>（3）照片须显示双耳、双眉、双肩；</p>
                <p>（4）不得上传全身照、半身照、风景照、生活照等；</p>
                <p>（5）不得进行过度PS处理，不得美颜；</p>
                <p>（6）不得佩戴首饰、头饰。</p>
              </div>
            </el-upload>
          </el-form-item>
          <div class="line">
            <el-form-item class="fl" label="姓名：" prop="regName">
              <el-input v-model="applyForm.regName" placeholder="请输入姓名" clearable></el-input>
            </el-form-item>
            <el-form-item class="sex fl" label="性别：" prop="regSex">
              <el-radio v-model="applyForm.regSex" label="0">男</el-radio>
              <el-radio v-model="applyForm.regSex" label="1">女</el-radio>
            </el-form-item>
          </div>
          <div class="line">
            <el-form-item label="身份证号：" prop="regIdcard">
              <el-input
                v-model="applyForm.regIdcard"
                placeholder="请输入身份证号"
                :disabled="isCard"
                @blur="analyzeIDCard"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="手机号：" prop="regTel">
              <el-input v-model="applyForm.regTel" placeholder="请输入手机号" clearable></el-input>
            </el-form-item>
          </div>
          <div class="line">
            <el-form-item label="选择专业：" prop="postId">
              <el-select
                v-model="applyForm.postId"
                placeholder="选择专业"
                clearable
                :disabled="isSpecial"
              >
                <el-option
                  v-for="item in specialList"
                  :key="item.postId"
                  :label="item.postName"
                  :value="item.postId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="学历：" prop="regOldPost">
              <el-select v-model="applyForm.regOldPost" placeholder="请选择学历" clearable>
                <el-option label="中职（含技工学校）" value="中职（含技工学校）"></el-option>
                <el-option label="专科（含高职和技师学院）" value="专科（含高职和技师学院）"></el-option>
                <el-option label="本科及以上" value="本科及以上"></el-option>
              </el-select>
            </el-form-item>

            <!-- <el-form-item class="sex" label="是否分配后台：" prop="regCategory" style="display:none">
              <el-radio v-model="applyForm.regCategory" label="3">否</el-radio>
              <el-radio v-model="applyForm.regCategory" label="2">是</el-radio>
            </el-form-item>-->
          </div>
          <div class="line">
            <el-form-item label="继续教育年份：" prop="learnYear">
              <el-input v-model="applyForm.learnYear" placeholder="请输入继续教育年份" clearable></el-input>
            </el-form-item>
            <el-form-item label="报名批次：" prop="batchId">
              <el-select v-model="applyForm.batchId" placeholder="报名批次" clearable>
                <el-option
                  v-for="(item, i) in batchList"
                  :key="i"
                  :label="item.batchName"
                  :value="item.batchId"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="line">
            <el-form-item label="证书编号：" prop="regCertificateNum">
              <el-input v-model="applyForm.regCertificateNum" placeholder="请输入证书编号" clearable></el-input>
            </el-form-item>
            <el-form-item label="证书发证时间：" prop="regCertificateDate">
              <!-- <el-input
                v-model="applyForm.regCertificateDate"
                placeholder="请输入证书发证时间"
                clearable
              ></el-input>-->
              <el-date-picker
                style="width: 100%;"
                v-model="applyForm.regCertificateDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="请选择"
              ></el-date-picker>
            </el-form-item>
          </div>
          <div class="line">
            <el-form-item label="所属企业：" prop="affiliatedEnterprise">
              <el-input v-model="applyForm.affiliatedEnterprise" placeholder="请输入企业名称" clearable></el-input>
            </el-form-item>
          </div>
          <el-form-item class="bot">
            <!-- <el-button type="primary" size="small" @click="applySave(state)">保存</el-button> -->
            <el-button
              type="primary"
              size="small"
              v-if="btnType === 0"
              @click="saveApply('applyForm')"
            >新增</el-button>
            <el-button type="primary" size="small" v-else @click="updateSave('applyForm')">修改</el-button>
            <el-button size="small" @click="applyDialog = false" plain>取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 批量导入报名信息 -->
      <el-dialog title="批量导入报名信息" :visible.sync="batchDialog" width="50%" center @close="batchBtn">
        <el-form id="applyPop" class="info" ref="batchForm" :model="batchForm" label-width="130px">
          <el-form-item label="模板下载：">
            <a class="download fl" href="https://bdy.hbzclm.com/templete.xlsx">模板下载</a>
            <!-- <a class="download fl" href="https://192.168.1.147:8082/templete.xlsx">模板下载</a> -->
          </el-form-item>
          <el-form-item label="选择文件：">
            <el-upload
              class="upload-demo fl"
              accept=".xls, .xlsx"
              ref="myFile"
              :action="fileUrl"
              :limit="limitNum"
              :auto-upload="false"
              :on-exceed="exceedFile"
              :on-change="fileChange"
              :on-success="handleSuccess"
              :file-list="fileList"
            >
              <!-- :on-error="handleError" -->
              <!-- :before-upload="beforeUploadFile" -->
              <!-- :on-success="fileSuccess" -->
              <!-- <el-input style="width: 60%" v-model="batchForm.fileName"></el-input> -->
              <el-button type="primary" size="small">选取文件</el-button>
              <div class="el-upload__tip" slot="tip">
                <h3>请上传符合要求的模板:</h3>
                <p>1.请使用下载的导入模板，尽量避免使用其他文档修改成模板的数据。</p>
                <p>2.导入的学员，身份证号、手机号、专业，不能出现重复，请仔细核对。</p>
                <p>3.学员的专业，需按第一行列表专业栏内标准文本来，通过选择填写，可以复制选项。</p>
                <p>4.学员批次，Excel的批次内容需提前在后台批次管理版块添加批次</p>
                <p>
                  5.复制其他文件的数据到模板文件中时，只粘贴文本数据
                  或匹配目标文件格式 避免输入了不可见的字符
                </p>
                <p>
                  6.模板数据填充完成之后 请删除
                  除模板板外的其他行列数据，避免系统识别到异常数据
                </p>
              </div>
              <!-- <el-button type="text" @click="download">批量模板下载</el-button> -->
            </el-upload>
          </el-form-item>
          <el-form-item class="bot">
            <el-button type="primary" size="small" @click="batchSure">确定</el-button>
            <el-button size="small" plain @click="batchCancel">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 批次管理 -->
      <el-dialog title="批次管理" :visible.sync="manageDialog" width="40%" center @open="getBatchList">
        <el-row style="margin-bottom: 20px">
          <el-button
            type="success"
            size="small"
            @click="
              (addDialog = true), (batchTitle = '新增批次'), (btnType = 0)
            "
          >新增批次</el-button>
        </el-row>
        <el-table
          :data="batchList"
          border
          max-height="400"
          highlight-current-row
          :header-cell-style="{ background: '#dde9fc', color: '#606266' }"
        >
          <!-- <el-table-column type="selection" width="50"></el-table-column> -->
          <el-table-column type="index" width="50" label="序号"></el-table-column>
          <el-table-column prop="batchName" label="批次名称" min-width="80"></el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="updateBatch(scope.row, scope.$index)">修改</el-button>
              <el-button type="danger" size="mini" @click="deleteBatch(scope.row, scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- <el-row style="margin-top: 20px;text-align:center">
          <el-button type="primary" size="small" @click="manageBtn">确定</el-button>
          <el-button size="small" @click="manageDialog = false">取消</el-button>
        </el-row>-->
      </el-dialog>
      <!-- 新增批次 -->
      <el-dialog
        :title="batchTitle"
        :visible.sync="addDialog"
        width="30%"
        center
        highlight-current-row
        :header-cell-style="{ background: '#dde9fc', color: '#606266' }"
        @close="resetForm('addForm')"
      >
        <el-form class="info" ref="addForm" :model="addForm" label-width="100px">
          <el-form-item label="批次名称：" style="width: 80%" prop="batchName">
            <el-input v-model="addForm.batchName" placeholder="请输入批次名称" clearable></el-input>
          </el-form-item>
          <el-form-item class="bot">
            <el-button type="primary" size="small" v-if="btnType === 0" @click="addBatchSave">新增</el-button>
            <el-button type="primary" size="small" v-else @click="getUpdateBatch">修改</el-button>
            <el-button size="small" plain @click="addDialog = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <span v-show="false">{{ updateNum }}</span>
    </div>
    <!-- 停学/取消停学弹窗 -->
    <el-dialog 
      title="学员报名列表"
      :visible.sync="suspensionDialog"
      width="70%"
      center
      highlight-current-row
      :header-cell-style="{ background: '#dde9fc', color: '#606266' }"
      @close="resetSuspensionForm"
      >
        <el-form style="margin-bottom: 20px" :inline="true" :model="formInlinePerson" size="small">
            <el-form-item style="width: 120px" prop="empName">
              <el-input v-model="formInlinePerson.empName" placeholder="姓名" clearable  @keyup.enter.native="onSearchPerson"></el-input>
            </el-form-item>
            <el-form-item prop="empIdcard" style="width: 180px">
              <el-input v-model="formInlinePerson.empIdcard" placeholder="证件号码" clearable  @keyup.enter.native="onSearchPerson"></el-input>
            </el-form-item>
            <el-form-item prop="affiliatedEnterprise">
              <el-input v-model="formInlinePerson.affiliatedEnterprise" placeholder="所属企业" clearable  @keyup.enter.native="onSearchPerson"></el-input>
            </el-form-item>
            <el-form-item prop="postId">
              <el-select
                v-model="postId"
                placeholder="专业"
                clearable
                @change="onSearchPerson"
              >
                <el-option
                  v-for="(item, i) in specialList"
                  :key="i"
                  :label="item.postName"
                  :value="item.postId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="batchId">
              <el-select v-model="formInlinePerson.batchId" placeholder="报名批次" clearable  @change="onSearchPerson">
                <el-option
                  v-for="(item, i) in batchList"
                  :key="i"
                  :label="item.batchName"
                  :value="item.batchId"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item prop="dataType">
              <el-select v-model="formInlinePerson.dataType" placeholder="报名类型" clearable>
                <el-option
                  v-for="(item, i) in dataTypeList"
                  :key="i"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item style="width: 120px" prop="agentId">
              <el-select
                v-model="formInlinePerson.agentId"
                placeholder="注册来源"
                clearable
                @change="onSearchPerson"
              >
                <el-option label="批量导入" value="0"></el-option>
                <el-option label="个人注册" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="regHasCourse">
              <el-select
                v-model="formInlinePerson.regHasCourse"
                placeholder="课程激活状态"
                clearable
                @change="onSearchPerson"
              >
                <el-option label="未激活" value="0"></el-option>
                <el-option label="已激活" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="sysDeleted" style="width: 150px">
              <el-select
                v-model="formInlinePerson.sysDeleted"
                placeholder="选择状态"
                clearable
                @change="onSearchPerson"
              >
                <el-option label="正常" value="0"></el-option>
                <el-option label="已作废" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="annualFlag" style="width: 150px">
              <el-select
                v-model="formInlinePerson.annualFlag"
                placeholder="标记类型"
                clearable
                @change="onSearchPerson"
              >
                <el-option label="否" value="0"></el-option>
                <el-option label="是" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-date-picker
              class="picker"
              style="margin-right: 10px"
              v-model="applyValue"
              type="datetimerange"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="报名时间起"
              end-placeholder="报名时间止"
              size="small"
              align="right"
              value-format="yyyy-MM-dd HH:mm:ss"
              unlink-panels
              @change="onSearchPerson"
            ></el-date-picker>
            <el-date-picker
              class="picker"
              style="margin-right: 10px"
              v-model="couseActiveValue"
              type="datetimerange"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="课程激活起"
              end-placeholder="课程激活止"
              size="small"
              align="right"
              value-format="yyyy-MM-dd HH:mm:ss"
              unlink-panels
              @change="onSearchPerson"
            ></el-date-picker>
            <el-button style="margin-right: 10px" type="primary" size="small" @click="onSearchPerson">查询</el-button>
            <el-button type="primary" style="margin-right: 10px;margin-bottom:20px;" v-if="formInlinePerson.suspensionType ==0" size="small" @click="suspensionMark">确定停学</el-button>
            <el-button type="danger" style="margin-bottom:20px;" v-if="formInlinePerson.suspensionType ==1" size="small" :disabled="isDisabled" @click="cancelSuspensionMarkMark">取消停学</el-button>
          </el-form>
          <el-table
            :data="infoListPerson"
            border
            max-height="600"
            ref="fileTable"
            :cell-style="cellStyle"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
            @row-click="rowClick"
            @selection-change="selectioSuspensionChange"
            highlight-current-row
            :header-cell-style="{ background: '#dde9fc', color: '#606266' }"
          >
              <el-table-column type="selection" width="50"></el-table-column>
              <el-table-column type="index" width="50" label="序号"></el-table-column>
              <el-table-column prop="regName" label="姓名" min-width="80"></el-table-column>
              <el-table-column prop="regSex" :formatter="sexFormat" label="性别" width="80"></el-table-column>
              <el-table-column prop="regIdcard" label="身份证号" min-width="180"></el-table-column>
              <el-table-column prop="regTel" label="手机号" min-width="120"></el-table-column>
              <el-table-column prop="postName" label="专业" min-width="120"></el-table-column>
              <el-table-column
                prop="affiliatedEnterprise"
                label="所属企业"
                min-width="120"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column prop="batchName" label="报名批次" show-overflow-tooltip min-width="120"></el-table-column>
              <el-table-column prop="agentId" label="注册方式" :formatter="orderFormat" width="100"></el-table-column>
              <el-table-column prop="regCertificateNum" label="证书编号" width="130"></el-table-column>
              <el-table-column prop="regCertificateDate" label="证书发证时间" width="120"></el-table-column>
              <el-table-column prop="sysCreatetimeStr" label="报名时间" min-width="160"></el-table-column>
              
              <el-table-column prop="suspensionType" label="是否停学" :formatter="suspensionFormat" width="120"></el-table-column>
              <!-- <el-table-column prop="regCategory" label="是否有后台权限" :formatter="hasFormat" width="120"></el-table-column> -->
              <el-table-column prop="learnYear" min-width="120" label="继续教育年份"></el-table-column>
              <!-- <el-table-column label="继续年度标记" min-width="120">
                <template slot-scope="scope">
                  {{scope.row.annualFlag==0?'否':'是'}}
                </template>
              </el-table-column> -->
              <el-table-column
                prop="regHasCourse"
                :formatter="stateFormat"
                min-width="120"
                label="课程激活状态"
              ></el-table-column>
              <el-table-column prop="activeTimeStr" min-width="160" label="课程激活时间"></el-table-column>
              <el-table-column prop="sysDeleted" label="状态" :formatter="sysFormat" width="100"></el-table-column>
              <el-table-column label="操作" width="160" fixed="right">
                <template slot-scope="scope">
                  <el-button
                    @click="updateBtn(scope.row, scope.$index)"
                    type="primary"
                    size="mini"
                    :disabled="scope.row.sysDeleted == 2"
                  >修改</el-button>
                  <!-- <el-button @click="deleteBtn(scope.row,scope.$index,2,'作废')" type="warning" size="mini"
                  v-if="scope.row.regHasCourse == 1 || scope.row.sysDeleted == 2" :disabled="scope.row.sysDeleted == 2">作废</el-button>-->
                  <el-button
                    @click="deleteBtn(scope.row, scope.$index, 1, '删除')"
                    type="danger"
                    size="mini"
                    v-if="scope.row.regHasCourse == 0"
                  >删除</el-button>
                </template>
              </el-table-column>
        </el-table>
        <pagination
          :currentPage="currentPage1"
          :total="total1"
          :limit="limit1"
          ref="page"
          @handleCurrentChange="handleCurrentChangeItem"
          @handleSizeChange="handleSizeChangeItem"
        />
      </el-dialog>
  </div>
</template>

<script>
import HeaderCom from "../components/Header.vue";
import http from "../api/module";
import { bizURL } from "../api/baseUrl";
import pagination from "../components/pagination";

export default {
  name: "student",
  data() {
    // 图片验证
    var valiIcon = (rule, value, callback) => {
      if (!this.applyForm.regHeadportrait) {
        // hasFmt设置为true/false
        callback(new Error("请上传本人登记照"));
      } else {
        callback();
      }
    };
    return {
      loading: true,
      currentPage: 1, // 当前页
      currentPage1:1,
      limit: 20, // 每页显示数量
      limit1: 20, // 每页显示数量
      total: 0, // 总条目数
      total1: 0, // 总条目数
      updateNum: 0,
      empIdList: [],
      applyValue: [],
      couseActiveValue: [],
      token: sessionStorage.getItem("token"),
      uploadUrl: bizURL + "/employee/uploadImage",
      fileUrl: `${bizURL}/registration/importRegister?tokenId=${sessionStorage.getItem(
        "token"
      )}`,
      title: "新增报名信息",
      infoList: [],
      infoListPerson:[],
      specialList: [],
      batchList: [],
      dataTypeList: [
        {
          label: "换证",
          value: "0"
        },
        {
          label: "继教",
          value: "1"
        }
      ],
      entpId: sessionStorage.getItem("entpId"),
      batchTitle: "新增批次",
      btnType: 0,
      isDisabled: false, // 课程激活是否禁用
      isSpecial: false, // 专业是否禁用
      isdataType: false, // 报名类型是否禁用
      isCard: false, // 身份证号是否禁用
      regHasCourse: false,
      postId:'',
      // stateList: [
      //   { postId: "0", postName: "未激活" },
      //   { postId: "1", postName: "已激活" }
      // ],
      dataForm: {},
      formInline: {},
      formInlinePerson:{},
      applyDialog: false,
      applyForm: {
        regHeadportrait: "",
        regName: "",
        regSex: "0",
        regIdcard: "",
        regTel: "",
        postId: "",
        // postName: "",
        regCategory: "3",
        batchId: "",
        regCertificateNum: "",
        regCertificateDate: "",
        // batchName: "",
        affiliatedEnterprise: "",
        regOldPost: "",
        learnYear: ""
      },
      applyRule: {
        // regHeadportrait: [
        //   { required: true, message: "请上传本人登记照", trigger: "change" }
        // ],
        regHeadportrait: [{ required: true, validator: valiIcon }],
        regName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        regIdcard: [
          { required: true, message: "请填写证件号码", trigger: "blur" },
          {
            pattern: /(^\d{15}$)|(^\d{17}([0-9]|x|X)$)/,
            message: "证件号码格式有误！",
            trigger: "blur"
          }
        ],
        regTel: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { pattern: /^1\d{10}$/, message: "手机号格式不对", trigger: "blur" }
        ],
        postId: [{ required: true, message: "请选择专业", trigger: "change" }],
        regOldPost: [
          { required: true, message: "请选择学历", trigger: "change" }
        ],
        learnYear: [
          { required: true, message: "请选择继续教育年份", trigger: "blur" },
          {
            pattern: /^20\d{2}$/,
            message: "请输入正确的继续教育年份",
            trigger: "blur"
          }
        ],
        regCertificateNum: [
          { required: true, message: "请输入证书编号", trigger: "blur" }
        ],
        regCertificateDate: [
          { required: true, message: "请选择证书发证时间", trigger: "blur" }
        ],
        affiliatedEnterprise: [
          { required: true, message: "请输入企业名称", trigger: "blur" }
        ]
      },
      batchDialog: false,
      batchForm: {
        fileName: ""
      },
      manageDialog: false,
      manageForm: {
        fileName: ""
      },
      addDialog: false,
      addForm: {
        batchName: ""
      },
      activeDialog: false,
      activeForm: {
        name: ""
      },
      tableData: [],
      multipleSelection: [], // 表格被选中的内容
      limitNum: 1, // 上传excell时，同时允许上传的最大数
      fileList: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      suspensionDialog:false, //停学弹窗
      multipleSuspensionSelection: [], // 弹窗表格被选中的内容
      formInlinePerson:{}
    };
  },
  components: {
    HeaderCom,
    pagination
  },
  mounted() {
    this.getPostList();
    this.getBatchList();
    this.getInfo();
  },
  computed: {},
  methods: {
    analyzeIDCard() {
      if (
        this.applyForm.regIdcard == "" ||
        this.applyForm.regIdcard.length != 18
      ) {
        return false;
      }
      this.applyForm = JSON.parse(JSON.stringify(this.applyForm));
      // 获取用户身份证号码
      const userCard = this.applyForm.regIdcard;
      // 获取性别
      if (parseInt(userCard.substr(16, 1)) % 2 == 1) {
        this.applyForm.regSex = "0";
      } else {
        this.applyForm.regSex = "1";
      }
      // 获取出生年月日
      // const yearBirth = userCard.substring(6, 10)
      // const monthBirth = userCard.substring(10, 12)
      // const dayBirth = userCard.substring(12, 14)
      // this.applyForm.regBirthdate = yearBirth + '-' + monthBirth + '-' + dayBirth
    },
    // 清空上传文件列表
    batchBtn() {
      this.$refs.myFile.clearFiles();
    },
    //表格数据转义
    dataTypeFormatter(row) {
      return row.dataType == 0 ? "换证" : "继教";
    },
    /* 弹框表单清空 */
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.regHasCourse = false;
    },

    /* 弹框表单清空 */
    resetSuspensionForm() {
      this.currentPage1 = 1
      this.suspensionDialog = false;
      this.formInlinePerson = {}
      this.postId =''
    },
    beforeUpload(file) {
      const isLt80k = file.size / 1024 < 80;
      if (!isLt80k) {
        this.$message.warning({
          duration: 1000,
          message: "上传图片大小不能超过 80k！"
        });
      }
      return isLt80k;
    },
    // 获取上传图片路径
    handleAvatarSuccess(res, file, fileList) {
      this.applyForm.regHeadportrait = res.data;
      this.$refs.regHeadportrait.clearValidate(); // 清空头像
      this.updateNum++;
    },
    // 文件超出个数限制时的钩子
    exceedFile(files, fileList) {
      this.$message.warning({
        duration: 2000,
        message: `只能选择 ${
          this.limitNum
        } 个文件，当前共选择了 ${files.length + fileList.length} 个`
      });
    },
    // 文件状态改变时的钩子
    fileChange(file, fileList) {
      this.fileList = fileList;
      // this.fileList.push(file.raw);
    },
    // 文件上传成功时的钩子
    handleSuccess(res, file, fileList) {
      if (res.code == "200" || res.success == true) {
        this.$message.success({
          duration: 1000,
          message: "文件上传成功"
        });
        this.$refs.myFile.clearFiles();
        this.batchDialog = false;
        this.getInfo();
      } else {
        this.$message.error({
          duration: 1000,
          message: res.message
        });
      }
    },
    batchSure() {
      if (!this.fileList.length) {
        this.$message.warning({
          duration: 1000,
          message: "请先上传文件！"
        });
      } else {
        this.$refs.myFile.submit();
      }
    },
    batchCancel() {
      this.$refs.myFile.clearFiles();
      this.batchDialog = false;
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 17) {
        return row.regHasCourse == 0 ? "color:#F56C6C" : "color:#67C23A";
      } else if (columnIndex === 19) {
        return row.sysDeleted == 2 ? "color:#F56C6C" : "color:#67C23A";
      } else {
        return "";
      }
    },
    specialChange(val) {
      this.postId = val;
      this.onSearch()
    },
    activeState(val) {
      this.formInline.activeState = val;
      this.onSearch()
    },
    stateChange(val) {
      this.formInline.sysDeleted = val;
      this.onSearch()
    },
    startTime(val) {
      this.formInline.startTime = val;
      this.onSearch()
    },
    endTime(val) {
      this.formInline.endTime = val;
      this.onSearch()
    },
    // 获取注册专业
    getPostList() {
      http
        .getSpecial()
        .then(data => {
          if (data.data.code == "200" || data.data.success == true) {
            this.specialList = data.data.data;
            // sessionStorage.setItem('specialList',data.data.data);
            sessionStorage.setItem(
              "specialList",
              JSON.stringify(data.data.data)
            );
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(error => {
          this.$message.error({
            duration: 1000,
            message: "请求失败，请联系管理员！"
          });
        });
    },
    // 获取批次列表
    getBatchList() {
      http
        .getBatch({
          pageNum: this.currentPage,
          pageSize: 1000
        })
        .then(data => {
          if (data.data.success == true) {
            this.batchList = data.data.data;
            // sessionStorage.setItem('batchList',data.data.data);
            sessionStorage.setItem("batchList", JSON.stringify(data.data.data));
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(error => {
          this.$message.error({
            duration: 1000,
            message: "请求失败，请联系管理员！"
          });
        });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getInfo();
    },
    handleSizeChange(val) {
      this.currentPage = 1;
      this.limit = val;
      this.getInfo();
    },
    // 批量导出报名信息
    exportApply() {
      var url = `${bizURL}/registration/getRegistrationEmployeeList?tokenId=${sessionStorage.getItem(
        "token"
      )}&entpId=${sessionStorage.getItem("entpId")}&export=1&`;

      var data = {
        empName: this.formInline.empName,
        empIdcard: this.formInline.empIdcard,
        affiliatedEnterprise: this.formInline.affiliatedEnterprise,
        postId: this.postId,
        agentId: this.formInline.agentId,
        batchId: this.formInline.batchId,
        regHasCourse: this.formInline.regHasCourse,
        sysDeleted: this.formInline.sysDeleted,
        dataType: this.formInline.dataType,
        startTime: this.applyValue ? this.applyValue[0] : null,
        endTime: this.applyValue ? this.applyValue[1] : null,
        startActiveTime: this.couseActiveValue
          ? this.couseActiveValue[0]
          : null,
        endtActiveTime: this.couseActiveValue ? this.couseActiveValue[1] : null
      };
      Object.keys(data).map(key => {
        if (data[key] != undefined && data[key] != null) {
          url += key + "=" + data[key] + "&";
        }
      });
      // url = url.substring(url.length - 1, 1)

      console.log(url); // 输出结果  hfcrm/cm/api/user?download=1a=11&b=22&c=33
      window.location.href = url;
    },
    onSearch() {
      this.currentPage = 1;
      this.$refs.page.init();
      this.getInfo();
    },
    // 获取列表信息
    getInfo() {
      http
        .getUserInfo({
          pageNum: this.currentPage,
          pageSize: this.limit,
          annualFlag:this.formInline.annualFlag,
          empName: this.formInline.empName,
          empIdcard: this.formInline.empIdcard,
          affiliatedEnterprise: this.formInline.affiliatedEnterprise,
          postId: this.postId,
          agentId: this.formInline.agentId,
          batchId: this.formInline.batchId,
          dataType: this.formInline.dataType,
          regHasCourse: this.formInline.regHasCourse,
          sysDeleted: this.formInline.sysDeleted,
          suspensionType: this.formInline.suspensionType,
          startTime: this.applyValue ? this.applyValue[0] : null,
          endTime: this.applyValue ? this.applyValue[1] : null,
          startActiveTime: this.couseActiveValue
            ? this.couseActiveValue[0]
            : null,
          endtActiveTime: this.couseActiveValue
            ? this.couseActiveValue[1]
            : null
        })
        .then(data => {
          if (data.data.code == "200" || data.data.success == true) {
            this.loading = false;
            this.infoList = data.data.data.map((item, i) => {
              item.index = i;
              return item;
            });
            this.total = data.data.total;
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(error => {
          this.$message.error({
            duration: 1000,
            message: "请求失败，请联系管理员！"
          });
        });
    },
    onSearchPerson(){
      this.currentPage1 = 1;
      this.$refs.page.init();
      this.getInfoItem();
    },

    // 获取列表信息----弹窗
    getInfoItem() {
      http
        .getUserInfo({
          pageNum: this.currentPage1,
          pageSize: this.limit1,
          annualFlag:this.formInlinePerson.annualFlag,
          empName: this.formInlinePerson.empName,
          empIdcard: this.formInlinePerson.empIdcard,
          affiliatedEnterprise: this.formInlinePerson.affiliatedEnterprise,
          postId: this.postId,
          agentId: this.formInlinePerson.agentId,
          batchId: this.formInlinePerson.batchId,
          dataType: this.formInlinePerson.dataType,
          regHasCourse: this.formInlinePerson.regHasCourse,
          sysDeleted: this.formInlinePerson.sysDeleted,
          suspensionType: this.formInlinePerson.suspensionType,
          startTime: this.applyValue ? this.applyValue[0] : null,
          endTime: this.applyValue ? this.applyValue[1] : null,
          startActiveTime: this.couseActiveValue
            ? this.couseActiveValue[0]
            : null,
          endtActiveTime: this.couseActiveValue
            ? this.couseActiveValue[1]
            : null
        })
        .then(data => {
          if (data.data.code == "200" || data.data.success == true) {
            this.loading = false;
            this.infoListPerson = data.data.data.map((item, i) => {
              item.index = i;
              return item;
            });
            this.total1 = data.data.total;
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(error => {
          this.$message.error({
            duration: 1000,
            message: "请求失败，请联系管理员！"
          });
        });
    },
      handleCurrentChangeItem(val) {
      this.currentPage1 = val;
      this.getInfoItem();
    },
    handleSizeChangeItem(val) {
      this.currentPage1 = 1;
      this.limit1 = val;
      this.getInfoItem();
    },
    sexFormat(row) {
      var regSex = row.regSex;
      return regSex == "0" ? "男" : "女";
    },
    orderFormat(row) {
      var agentId = row.sysOrder;
      return agentId == "1" ? "个人注册" : "批量导入";
    },
    hasFormat(row) {
      var regCategory = row.regCategory;
      return regCategory == "2" ? "是" : "否";
    },
    suspensionFormat(row) {
      var suspensionType = row.suspensionType;
      return suspensionType == "1" ? "是" : "否";
    },
    
    sysFormat(row) {
      var sysDeleted = row.sysDeleted;
      return sysDeleted == "0" ? "正常" : "作废";
    },
    stateFormat(row, column) {
      var state = row.regHasCourse;
      return state == "0" ? "未激活" : "已激活";
    },
    // 报名信息新增
    saveApply(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          http
            .addRegister({
              postId: this.applyForm.postId,
              regHeadportrait: this.applyForm.regHeadportrait,
              regName: this.applyForm.regName,
              regSex: this.applyForm.regSex,
              regIdcard: this.applyForm.regIdcard || "",
              affiliatedEnterprise: this.applyForm.affiliatedEnterprise || "",
              regCertificateNum: this.applyForm.regCertificateNum || "",
              regCertificateDate: this.applyForm.regCertificateDate || "",
              regTel: this.applyForm.regTel || "",
              regBatch: this.applyForm.batchId || "",
              regOldPost: this.applyForm.regOldPost,
              regCategory: this.applyForm.regCategory,
              learnYear: this.applyForm.learnYear
            })
            .then(data => {
              if (data.data.code == "200" || data.data.success == true) {
                this.$message.success({
                  duration: 1000,
                  message: "新增成功"
                });
                this.applyDialog = false;
                this.getInfo();
              } else {
                this.$message.error({
                  duration: 1000,
                  message: data.data.message
                });
              }
            })
            .catch(error => {
              this.$message.error({
                duration: 1000,
                message: "请求失败，请联系管理员！"
              });
            });
        } else {
          return false;
        }
      });
    },
    // 修改获取单个报名记录
    updateBtn(params, index) {
      this.applyDialog = true;
      this.title = "修改报名信息";
      this.btnType = 1;
      this.isCard = true;
      this.regId = params.regId;
      this.empId = params.empId;
      if (params.regHasCourse == 0) {
        this.regHasCourse = false;
      } else {
        this.regHasCourse = true;
      }
      http
        .getRegistration({
          regId: this.regId
        })
        .then(data => {
          if (data.data.code == "200" || data.data.success == true) {
            var data = data.data.data;
            if (data.regHasCourse == 1) {
              // 已激活的不能修改专业
              this.isSpecial = true;
              this.isdataType = true;
            } else {
              this.isSpecial = false;
              this.isdataType = false;
            }
            this.applyForm.regHeadportrait = data.regHeadportrait;
            this.applyForm.regName = data.regName;
            this.applyForm.regSex = data.regSex;
            this.applyForm.regIdcard = data.regIdcard;
            this.applyForm.regTel = data.regTel;
            this.applyForm.postId = data.postId ? data.postId * 1 : data.postId;
            // this.applyForm.postName = data.postName;
            this.applyForm.regCategory = data.regCategory;
            // this.applyForm.batchName = data.batchName;
            this.applyForm.batchId = data.regBatch
              ? data.regBatch * 1
              : data.regBatch;
            this.applyForm.affiliatedEnterprise = data.affiliatedEnterprise;
            this.applyForm.regOldPost = data.regOldPost;
            this.applyForm.learnYear = data.learnYear;
            this.applyForm.regCertificateNum = data.regCertificateNum;
            this.applyForm.regCertificateDate = data.regCertificateDate;
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(error => {
          this.$message.error({
            duration: 1000,
            message: "请求失败，请联系管理员！"
          });
        });
    },
    // 修改报名信息
    updateSave(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          http
            .updateRegister({
              regId: this.regId,
              empId: this.empId,
              entpId: this.entpId,
              regHeadportrait: this.applyForm.regHeadportrait,
              regName: this.applyForm.regName,
              regSex: this.applyForm.regSex,
              regIdcard: this.applyForm.regIdcard || "",
              affiliatedEnterprise: this.applyForm.affiliatedEnterprise || "",
              regCertificateNum: this.applyForm.regCertificateNum || "",
              regCertificateDate: this.applyForm.regCertificateDate || "",
              regTel: this.applyForm.regTel || "",
              postId: this.applyForm.postId,
              // regBatch: this.applyForm.batchName,
              regBatch: this.applyForm.batchId || "",
              regOldPost: this.applyForm.regOldPost,
              regCategory: this.applyForm.regCategory,
              learnYear: this.applyForm.learnYear
            })
            .then(data => {
              if (data.data.code == "200" || data.data.success == true) {
                this.applyDialog = false;
                this.$message.success({
                  duration: 1000,
                  message: "修改成功"
                });
                this.getInfo();
              } else {
                this.$message.error({
                  duration: 1000,
                  message: data.data.message
                });
              }
            })
            .catch(error => {
              this.$message.error({
                duration: 1000,
                message: "请求失败，请联系管理员！"
              });
            });
        } else {
          return false;
        }
      });
    },
    // 删除:1 /作废:2 报名
    deleteBtn(params, index, state, text) {
      var regId = params.regId;
      this.$confirm(`确定要${text}吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.delete(regId, state, text);
        })
        .catch(() => {
          this.$message.info({
            duration: 1000,
            message: `已取消${text}!`
          });
        });
    },
    delete(regId, state, text) {
      http
        .deleteRegister({
          regId: regId,
          sysDeleted: state // 1删除  2:作废
        })
        .then(data => {
          if (data.data.code == "200" || data.data.success == true) {
            this.$message.success({
              duration: 1000,
              // message: "作废成功!"
              message: `${text}成功!`
            });

            this.getInfo();
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(error => {
          this.$message.error({
            duration: 1000,
            message: "请求失败，请联系管理员！"
          });
        });
    },
    // 新增批次
    addBatchSave() {
      http
        .addBatch({
          batchName: this.addForm.batchName
        })
        .then(data => {
          if (data.data.code == "200" || data.data.success == true) {
            this.addDialog = false;
            this.getBatchList();
            this.btnType = 0;
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(error => {
          this.$message.error({
            duration: 1000,
            message: "请求失败，请联系管理员！"
          });
        });
    },
    updateBatch(params) {
      this.batchId = params.batchId;
      this.addDialog = true;
      this.btnType = 1;
      this.batchTitle = "修改批次";
      http
        .batchDetail({
          batchId: this.batchId
        })
        .then(data => {
          if (data.data.code == "200" || data.data.success == true) {
            this.addForm.batchName = data.data.data.batchName;
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(error => {
          this.$message.error({
            duration: 1000,
            message: "请求失败，请联系管理员！"
          });
        });
    },
    getUpdateBatch() {
      http
        .updateBatch({
          batchId: this.batchId,
          batchName: this.addForm.batchName
        })
        .then(data => {
          if (data.data.code == "200" || data.data.success == true) {
            this.btnType = 0;
            this.addDialog = false;
            this.getBatchList();
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(error => {
          this.$message.error({
            duration: 1000,
            message: "请求失败，请联系管理员！"
          });
        });
    },
    // 删除批次
    deleteBatch(params) {
      var batchId = params.batchId;
      http
        .deleteBatch({
          batchId: batchId
        })
        .then(data => {
          if (data.data.code == "200" || data.data.success == true) {
            this.$message.success({
              duration: 1000,
              message: "删除成功!"
            });
            this.getBatchList();
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(error => {
          this.$message.error({
            duration: 1000,
            message: "请求失败，请联系管理员！"
          });
        });
    },
    // 当某一行被点击时触发
    rowClick(row, column, event) {
      if (row.regHasCourse == 1) {
        // this.$message({
        //   type: "warning",
        //   duration: 1000,
        //   message: "已激活的课程不能再次激活,请重新选择!"
        // });
        return;
      }
      // console.log(row, "rowClick");
      // console.log(event, "event");
      this.$refs.fileTable.toggleRowSelection(row);
    },
    // 设置选中颜色
    rowStyle({ row, rowIndex }) {
      // :row-class-name="rowStyle"
      let arr = this.multipleSelection;
      for (let i = 0; i < arr.length; i++) {
        if (rowIndex === arr[i].index) {
          return "rowStyle";
        }
      }
    },

    // 当选择项发生变化时触发
    selectioChange(selection) {
      // console.log(selection, "selection");
      // selection.isCheck = !selection.isCheck;
      this.multipleSelection = selection;
      // this.list = selection;
      this.regIdList = [];
      this.empIdList = [];
      this.courseIdList = [];
      this.delList = [];
      this.multipleSelection.forEach(item => {
        // item.isCheck = false;
        this.regIdList.push(item.regId);
        if (item.regHasCourse != "1") {
          // item.isCheck = true;
          this.empIdList.push(item.empId);
          this.courseIdList.push(item.courseId);
          this.delList.push(item.sysDeleted);
        }
        if (item.sysDeleted == 1) {
          this.isDisabled = true;
          this.$message.warning({
            duration: 1000,
            message: "已作废的课程不能再次激活!"
          });
        } else {
          this.isDisabled = false;
        }
      });
    },

    //勾选停学的
    selectioSuspensionChange(selection){
      this.multipleSuspensionSelection = selection;
    },
    // 激活课程
    activeBtn() {
      // console.log(this.empIdList.length, 123);
      if (this.empIdList.length) {
        // console.log(this.multipleSelection,'this.multipleSelection')
        if (this.multipleSelection) {
          this.$confirm("确定要激活课程?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(() => {
              this.getCourse();
            })
            .catch(() => {
              this.$message.info({
                duration: 1000,
                message: "已取消激活！"
              });
            });
        }
      } else {
        this.$message.warning({
          duration: 1000,
          message: "请先选择学员，再激活课程！"
        });
      }
    },
    // 激活课程
    getCourse() {
      http
        .getSaveCourse({
          regId: this.regIdList,
          empId: this.empIdList,
          courseId: this.courseIdList
        })
        .then(data => {
          if (data.data.success == true) {
            this.$message.success({
              duration: 1000,
              message: "激活成功！"
            });
            this.getInfo();
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
            this.getInfo();
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 已激活后禁止勾选
    selectable(row, index) {
      // console.log(row, "row");
      // console.log(index, "index");
      var state = row.regHasCourse;
      if (state == "1") {
        return false;
      } else {
        return true;
      }
    },
    //停学弹窗显示
    suspensionMarkClick(val){
      this.suspensionDialog = true
      this.formInlinePerson.suspensionType = val
      this.getInfoItem()
    },
    // 停学标记
    suspensionMark(){
      if(this.multipleSuspensionSelection.length<1){
          this.$message({
            type: 'warning',
            message: '请选择需要停学的数据!'
          });
        }else{
        this.$confirm('是否确定标记该数据为已停学??', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let regIds = []
            for(var i in this.multipleSuspensionSelection){
              regIds.push(this.multipleSuspensionSelection[i].regId)
            }
            let data ={
              // regId:this.multipleSuspensionSelection[0].regId,
              regIds:regIds.join(','),
              suspensionType:1
            }
            http.updateSuspensionType(data).then(res => {
            if (res.data.code ==200) {
               this.$message({
                type: 'success',
                message: res.data.message
              });
              this.suspensionDialog = false
              this.getInfo()
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });          
        });
      }
    },

     //取消停学标记弹窗显示
    cancelSuspensionMarkMarkClick(val){
      this.suspensionDialog = true
      this.formInlinePerson.suspensionType = val
      this.getInfoItem()
    },
    // 取消停学标记
    cancelSuspensionMarkMark(){
      if(this.multipleSuspensionSelection.length<1){
          this.$message({
            type: 'warning',
            message: '请选择需要标记的数据!'
          });
        }else{
            this.$confirm('是否确定取消停学标记?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              let regIds = []
              for(var i in this.multipleSuspensionSelection){
                regIds.push(this.multipleSuspensionSelection[i].regId)
              }
              let data ={
              // regId:this.multipleSuspensionSelection[0].regId,
                regIds:regIds.join(','),
                suspensionType:0
              }
            http.updateSuspensionType(data).then(res => {
            if (res.data.code) {
                this.$message({
                  type: 'success',
                  message: res.data.message
                });
                 this.suspensionDialog = false
                this.getInfo()
              }
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });          
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>
@media screen and (min-width: 768px) and (max-width: 1600px) {
  .btns {
    margin-top: 20px;
  }
  /deep/.el-dialog {
    width: 80% !important;
  }
}
/deep/.rowStyle td {
  background-color: #bad0f3 !important;
}
.avatar-uploader {
  width: 90%;
  height: 190px !important;
}
.avatar-uploader-icon {
  width: 130px;
  height: 190px;
  line-height: 190px;
}
#addPop /deep/.el-upload.el-upload--text {
  width: 130px;
  height: 190px;
}
.avatar {
  width: 100%;
  height: auto;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.el-icon-plus.avatar-uploader-icon {
  line-height: 190px;
}
#addPop .el-upload__tip {
  top: 91% !important;
  margin-left: 20px;
  p {
    line-height: 24px;
  }
}
#applyPop .el-upload__tip {
  position: absolute;
  left: 100px;
  top: 100px;
  color: red;
  p {
    line-height: 24px;
  }
}
/deep/.el-upload-list.el-upload-list--text {
  margin-top: 80px;
}
.cont {
  margin-top: 20px;
  .wrap {
    padding: 20px;
  }
  .title {
    font-size: 18px;
    line-height: 40px;
    border-bottom: 1px solid #ddd;
    padding: 0 20px;
    font-weight: normal;
  }
  .btns {
    padding-bottom: 20px;
  }
}
.info {
  .line {
    overflow: hidden;
    /deep/.el-form-item {
      width: 44%;
      display: inline-block;
      margin-right: 50px;
    }
    /deep/.el-select {
      width: 100%;
    }
  }
  .upload-demo {
    display: inline-block;
  }
  .el-button--text {
    margin-left: 10px;
  }
  .bot {
    /deep/.el-form-item__content {
      margin-left: 0 !important;
      text-align: center;
      // margin-top: 70px;
    }
  }
  .download {
    color: #409eff;
    margin-left: 10px;
    text-decoration: underline;
  }
}
.top {
  margin-bottom: 20px;
  font-size: 16px;
}
</style>
